<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Numberings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
  >
    <ItpBox
      direction="column"
    >
      <ItpBox>
        <ItpButton
          :text="'Add numbering...'|pgettext('Numberings')"
          @click="evh_4615685607825208_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :text="'Reload'|pgettext('Numberings')"
          @click="evh_2095089031469157_click($event, {})"
        >
        </ItpButton>
      </ItpBox>
      <ItpDataTable
        tableId="Settings.Numberings"
        :editable="b_8320016629450276_editable"
        no-create-row
        no-delete-row
        :value="_.orderBy(items, ['key', 'description'])"
        :columns="b_8320016629450276_columns"
        class="h-100"
        ref="table"
        v-if="loaded"
        @save="evh_8320016629450276_save($event, {})"
        @delete="evh_8320016629450276_delete($event, {})"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpDataTable>
    </ItpBox>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.numberings",
    path: "numberings",
    component: "Numberings"
  }
)

@Component()
export default class Numberings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_numbering')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_8320016629450276_editable!: any;
  b_8320016629450276_columns!: any;
  dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_8320016629450276_editable', 'b_8320016629450276_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_8320016629450276_editable: false,
        b_8320016629450276_columns: [{
          name: "key",
          header: this.$fn.pgettext("Numbering", "Key"),
          type: "link",
          width: "120px",
        }
          ,
        {
          name: "resource_type",
          header: this.$fn.pgettext("Numbering", "Resource Type"),
          width: "120px",
        }
          ,
        {
          name: "description",
          header: this.$fn.pgettext("Numbering", "Description"),
          width: "160px",
        }
          ,
        {
          name: "format",
          header: this.$fn.pgettext("Numbering", "Format"),
          width: "260px",
        }
          ,
        {
          name: "increment",
          type: "number",
          header: this.$fn.pgettext("Numbering", "Increment"),
          width: "110px",
        }
          ,
        {
          name: "next_value",
          type: "number",
          header: this.$fn.pgettext("Numbering", "Next value"),
          width: "110px",
        }
          ,
        {
          name: "next_number",
          type: "number",
          header: this.$fn.pgettext("Numbering", "Next Number"),
          width: "110px",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5224_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5224, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_4615685607825208_showModal_5226_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4615685607825208_showModal_5226, alias=undefined
    return {
      name: "Numbering",
    }
  }

  async evh_4615685607825208_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4615685607825208_click.executeFromDOM(this, event, scope);
  }

  async evh_2095089031469157_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2095089031469157_click.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_script_5230_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8320016629450276_script_5230, alias=undefined
    $event.data.waitFor(
      this.$fn.crud('numbering').upsert({
        ...$event.data.row,
        start: $event.data.row.lastvalue
      })
    )
  }

  async act_8320016629450276_script_5230_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8320016629450276_script_5230, alias=undefined
    return {
      value: () => this.act_8320016629450276_script_5230_getActionArgs_value($event),
    }
  }

  async evh_8320016629450276_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_save.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_script_5232_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8320016629450276_script_5232, alias=undefined
    $event.data.waitFor(this.$fn.crud('numbering').delete($event.data.row))
  }

  async act_8320016629450276_script_5232_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8320016629450276_script_5232, alias=undefined
    return {
      value: () => this.act_8320016629450276_script_5232_getActionArgs_value($event),
    }
  }

  async evh_8320016629450276_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_delete.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_showModal_5234_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_5234, alias=undefined
    return {
      name: "Numbering",
      props: {
        oid: $event.data.row.id,
      }
      ,
    }
  }

  async evh_8320016629450276_click_5233_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_click_5233, alias=undefined
    return $event.data.col.name === 'key'
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5224: actions.CloseModalAction;
    evh_7315092382398562_close_5223: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_4615685607825208_showModal_5226: actions.ShowModalAction;
    evh_4615685607825208_click_5225: actions.EventHandlerImpl;
    evh_4615685607825208_click: actions.EventHandlerGroup;
    act_2095089031469157_reloadComponentData_5228: actions.ReloadComponentDataAction;
    evh_2095089031469157_click_5227: actions.EventHandlerImpl;
    evh_2095089031469157_click: actions.EventHandlerGroup;
    act_8320016629450276_script_5230: actions.ScriptAction;
    evh_8320016629450276_save_5229: actions.EventHandlerImpl;
    evh_8320016629450276_save: actions.EventHandlerGroup;
    act_8320016629450276_script_5232: actions.ScriptAction;
    evh_8320016629450276_delete_5231: actions.EventHandlerImpl;
    evh_8320016629450276_delete: actions.EventHandlerGroup;
    act_8320016629450276_showModal_5234: actions.ShowModalAction;
    evh_8320016629450276_click_5233: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5224 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5224_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5223 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5224,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5223],
      }
    );
    const act_4615685607825208_showModal_5226 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4615685607825208_showModal_5226_getActionArgs,
        events: [],
      }
    );
    const evh_4615685607825208_click_5225 = new actions.EventHandlerImpl(
      {
        action: act_4615685607825208_showModal_5226,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_4615685607825208_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4615685607825208_click_5225],
      }
    );
    const act_2095089031469157_reloadComponentData_5228 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2095089031469157_click_5227 = new actions.EventHandlerImpl(
      {
        action: act_2095089031469157_reloadComponentData_5228,
        event: "click",
        displayName: "reloadComponentData",
      }
    );
    const evh_2095089031469157_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2095089031469157_click_5227],
      }
    );
    const act_8320016629450276_script_5230 = new actions.ScriptAction(
      {
        actionArgs: this.act_8320016629450276_script_5230_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_save_5229 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_script_5230,
        event: "save",
        displayName: "script",
      }
    );
    const evh_8320016629450276_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_save_5229],
      }
    );
    const act_8320016629450276_script_5232 = new actions.ScriptAction(
      {
        actionArgs: this.act_8320016629450276_script_5232_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_delete_5231 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_script_5232,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_8320016629450276_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_delete_5231],
      }
    );
    const act_8320016629450276_showModal_5234 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_5234_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_click_5233 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_5234,
        event: "click",
        when: this.evh_8320016629450276_click_5233_getWhen,
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_5233],
      }
    );
    return {
      act_7315092382398562_closeModal_5224,
      evh_7315092382398562_close_5223,
      evh_7315092382398562_close,
      act_4615685607825208_showModal_5226,
      evh_4615685607825208_click_5225,
      evh_4615685607825208_click,
      act_2095089031469157_reloadComponentData_5228,
      evh_2095089031469157_click_5227,
      evh_2095089031469157_click,
      act_8320016629450276_script_5230,
      evh_8320016629450276_save_5229,
      evh_8320016629450276_save,
      act_8320016629450276_script_5232,
      evh_8320016629450276_delete_5231,
      evh_8320016629450276_delete,
      act_8320016629450276_showModal_5234,
      evh_8320016629450276_click_5233,
      evh_8320016629450276_click,
    }
  }
}

Vue.component("Numberings", Numberings);

</script>